<template>
  <FITFormCard>
    <div slot="header">
      <h3>{{$t('adm.userAuthorization.header')}}</h3>
    </div>
    <div slot="formBody">
      <FITAlert ref="batchActionSuccessAlert" :alertSec="2">
        <span slot="content">
          <span class="fa fa-check-circle pr-2"></span> {{ $t('adm.userAuthorization.list.success') }}
        </span>
      </FITAlert>
      <FITAlert ref="batchActionErrorAlert" :alertSec="2">
        <span slot="content">
          <span class="fa fa-times-circle pr-2"></span> {{ $t('adm.userAuthorization.list.error') }}
        </span>
      </FITAlert>
      <FITSearchableTable class="authorization-table" type="role" :columns="columns" :actions="actions" :filters="filters" vuexModule="UserAuthorization" searchAction="getAuthorizationList" @events="onReceiveEvent">
        <div slot="batchAction" slot-scope="batchActionCallback">
          <AuthorizationChange :candidates="batchActionCallback.selectedRows" :callback="{'onSuccess': batchActionCallback.onSuccess, 'onError': batchActionCallback.onError}">
          </AuthorizationChange>
        </div>
      </FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script>
import {
  FITFormCard,
  FITSearchableTable,
  FITAlert
} from '@/components'

import { mapGetters } from 'vuex'
import AuthorizationChange from './AuthorizationChange'
import Vue from 'vue'
export default {
  name: 'AuthorizationList',
  components: {
    FITFormCard,
    FITSearchableTable,
    AuthorizationChange,
    FITAlert
  },

  created() {
    this.$store.dispatch('UserAuthorization/getAuthorizationOption')
      .then((json) => {
        var list = json.data.map((role) => {
          return {
            text: role.name,
            value: role.name
          }
        })

        list.unshift({
          text: 'All',
          value: null
        });

        Vue.set(this, 'roles', list)

        var filters = this.filters;
        filters[0].options = this.roles;

        Vue.set(this, 'filters', filters)

        this.$forceUpdate();
      })
      .catch((err) => {
        console.debug(err);
      })


  },

  methods: {
    onReceiveEvent(payload) {
      switch (payload.event) {
        case 'onBatchActionSuccess':
          this.$refs.batchActionSuccessAlert.showAlert();
          break;
        case 'onBatchActionError':
          this.$refs.batchActionErrorAlert.showAlert();
          break;
      }
    },

    getTranslated(type, key) {

      if (!key) {
        return 'N/A';
      }


      let result = this.getTranslatedArray(this.$i18n.locale, 'UserAuthorization', type)
        .filter((item) => {
          return item.value === key
        });

      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray'])
  },

  data() {
    return {
      roles: [],
      columns: [{
        key: 'userType',
        label: this.$t('adm.userAuthorization.list.userType'),
        formatter: (row, key, item) => {
          return this.getTranslated('userType', row);
        },
        thClass: ['userType', 'text-center'],
        tdClass: ['text-center']
      }, {
        key: 'referenceCode',
        label: this.$t('adm.userAuthorization.list.referenceCode'),
        thClass: ['referenceCode'],
        tdClass: ['text-left']
      }, {
        key: 'englishName',
        label: this.$t('adm.userAuthorization.list.englishName'),
        thClass: ['englishName'],
        tdClass: ['text-left'],
        formatter: (row, key, item) => {
          let englishName = (item.englishName && item.englishName.trim().length > 0) ? item.englishName : 'N/A'
          let chineseName = (item.chineseName && item.chineseName.trim().length > 0) ? item.chineseName : 'N/A'
          return `${englishName}<br/>${chineseName}`
        }
      }, {
        key: 'roleName',
        label: this.$t('adm.userAuthorization.list.roleName'),
        sortable: true,
        thClass: ['role', 'text-left'],
        tdClass: ['text-left']
      }, {
        key: 'lastUpdateTime',
        label: 'Last Update Time',
        thClass: ['text-right', 'updateTime'],
        tdClass: ['text-right'],
        formatter: (row, key, item) => {
          return row
        }
      }],

      actions: [{
        text: this.$t('adm.userAuthorization.list.edit'),
        key: 'edit',
        callback: (key, row, item) => {
          this.$router.push({
            name: 'User Authorization Detail',
            params: { candidate: row }
          })
        }
      }],

      filters: [{
        label: this.$t('adm.userAuthorization.list.roleName'),
        key: 'roleName',
        type: 'select',
        options: [],
        default: null, // Default All
      }, {
        label: this.$t('adm.userAuthorization.list.userType'),
        key: 'userType',
        type: 'select',
        default: null // Default All
      }, ],
    }
  }
}

</script>
<style type="text/scss">
  .userType { width: 100px; } .referenceCode { width: 200px; } .englishName { width: 250px; } .role { width: 700px; }
</style>



// WEBPACK FOOTER //
// src/Adm/UserAuthorization/components/AuthorizationList.vue